export default __webpack_public_path__ + "static/media/forestly-expl-04_EN.1e92cb82.png";